module.exports = __webpack_public_path__ + "static/img/home_header_bkg_desktop.a92e0d71.png";